const mutations = {
  /**
   * Set the invites property on state
   * with invites parameter.
   *
   * @param state
   * @param invites
   */
  setInvites(state, invites) {
    state.invites = invites;
  },
};

export default mutations;
